import { render, staticRenderFns } from "./multiChoiceOtherItem.vue?vue&type=template&id=b2dcaedc"
import script from "./multiChoiceOtherItem.vue?vue&type=script&lang=js"
export * from "./multiChoiceOtherItem.vue?vue&type=script&lang=js"
import style0 from "./multiChoiceOtherItem.vue?vue&type=style&index=0&id=b2dcaedc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports